<template>
  <HalloweenGenericButton :disabled="isProcessing" @click="handleTokenAdd(token.nftAddress || '')">
    {{ $t('walletAddToWallet') }}
    <template #icon>
      <img src="/img/icons/mm-icon.png" alt="metamask" class="tw:mr-2" />
    </template>
  </HalloweenGenericButton>
</template>

<script lang="ts" setup>
import { useWeb3ModalProvider } from '@web3modal/ethers/vue';
import type { TokenDescription } from '~/types/token';

const { token } = defineProps<{
  token: TokenDescription;
}>();

const { addTokenToWallet } = useWalletMethods();
const { walletProvider } = useWeb3ModalProvider();

const isProcessing = ref(false);

const handleTokenAdd = async (tokenAddress: string): Promise<void> => {
  if (!walletProvider) {
    return;
  }

  const options = {
    address: tokenAddress,
    type: 'ERC721',
    decimals: 18,
    image: `https://pearldivergame.com${(getIcon(0, tokenAddress) || '').replace('/_nuxt/public', '')}`,
    tokenId: token.tokenId?.toString()
  };

  try {
    isProcessing.value = true;
    await addTokenToWallet(options);
  } finally {
    isProcessing.value = false;
  }
};
</script>
